import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import localizationUtils from './utils/localization.utils'

//import { initAuthentication } from "./services/common/authentication.service";
//await initAuthentication();

const i18n = localizationUtils.create();
//.use(authStore)
createApp(App).use(router).use(i18n).mount('#app')
